import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { SearchSvg } from "../../components/Assets";
import BottomSheet from "../../components/modal/BottomSheet";
import { REVIEW_STATUS_CODE } from "../../constants/AppConstants";
import ReviewFilterSetting from "./ReviewFilterSetting";
import {
  kIN_1_MONTH,
  kIN_1_WEEKS,
  kIN_3_MONTHS,
  krALL,
  krEXCLUDED,
  krEXPIRED,
  krFAILED,
  krIN_1_MONTH,
  krIN_1_WEEKS,
  krIN_3_MONTHS,
  krPENDING,
  krSUCCESS,
  krUNANSWERED,
  krYESTERDAY,
  kYESTERDAY
} from "./ReviewStatusKeys";

export default function ReviewSearch({ onSubmitSearch }) {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);
  const [searchParams, setSearchParams] = useSearchParams();

  const getSelectedTime = () => {
    if (!searchParams.get("time")) return krIN_1_WEEKS;
    switch (searchParams.get("time")) {
      case kYESTERDAY:
        return krYESTERDAY;

      case kIN_1_WEEKS:
        return krIN_1_WEEKS;

      case kIN_1_MONTH:
        return krIN_1_MONTH;

      case kIN_3_MONTHS:
        return krIN_3_MONTHS;

      default:
        return krIN_1_WEEKS;
    }
  };

  const getSelectedFilter = () => {
    if (!searchParams.get("search_comment_reg_status_code")) return krALL;
    switch (searchParams.get("search_comment_reg_status_code")) {
      case REVIEW_STATUS_CODE.ALL.code:
        return krALL;

      case REVIEW_STATUS_CODE.UNANSWERED.code:
        return krUNANSWERED;

      case REVIEW_STATUS_CODE.PENDING.code:
        return krPENDING;

      case REVIEW_STATUS_CODE.SUCCESS.code:
        return krSUCCESS;

      case REVIEW_STATUS_CODE.FAILED.code:
        return krFAILED;

      case REVIEW_STATUS_CODE.EXCLUDED.code:
        return krEXCLUDED;

      case REVIEW_STATUS_CODE.EXPIRED.code:
        return krEXPIRED;
      default:
        return krALL;
    }
  };

  return (
    <>
      <div
        className="mb-6 py-2 px-5 flex gap-3 items-center bg-gray"
        onClick={openModal}
      >
        <img src={SearchSvg} alt="Search" />
        <b>
          <span className="text-appblue">
            {getSelectedTime()}, {getSelectedFilter()}
          </span>{" "}
          <span className="font-normal">리뷰 입니다.</span>
        </b>
      </div>
      <BottomSheet isOpen={isOpen} closeModal={closeModal}>
        <ReviewFilterSetting
          closeModal={closeModal}
          onSubmitSearch={onSubmitSearch}
        />
      </BottomSheet>
    </>
  );
}
